// 带操作栏的Iframe
<template>
  <div>
    <van-nav-bar
      left-arrow
      @click-left="$router.go(-1)"
      left-arrow
      fixed
      placeholder
    />
    <iframe
      width="100%"
      :height="screenHeight"
      frameborder=”no”
      :src="urlOfIframe"
    />
  </div>
</template>
<script>
export default {
  name: "IframeWithBar",
  data() {
    const screenHeight = window.screen.height - 50;
    return {
      screenHeight: screenHeight,
      urlOfIframe: null,
    };
  },
  created() {
    this.urlOfIframe = this.$route.params.urlOfIframe;
  },
};
</script>